<template>
    <RowColumn :no-column-margin-top="true">
        <GoBackButton />
    </RowColumn>
</template>

<script>
    import GoBackButton from "./GoBackButton";
    import RowColumn from "./RowColumn";
    export default {
        name: "GoBackButtonRow",
        components: {RowColumn, GoBackButton}
    }
</script>

<style scoped>

</style>